export default "__VITE_ASSET__72tnPXH___"